import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-relatorio-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule],
  templateUrl: './relatorio-dialog.html',
  styleUrl: './relatorio-dialog.scss'
})
export class RelatorioDialogComponent {
  conteudoSeguro: SafeHtml;

  constructor(
    public dialogRef: MatDialogRef<RelatorioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { titulo: string; conteudo: string },
    private sanitizer: DomSanitizer
  ) {
    this.conteudoSeguro = this.sanitizer.bypassSecurityTrustHtml(data.conteudo);
  }

  fechar() {
    this.dialogRef.close();
  }

  // Método para converter HTML simples em texto formatado
  parseHtml(html: string): string {
    // Remove tags HTML mantendo o texto
    return html.replace(/<[^>]*>/g, '');
  }
}

